module.exports = __webpack_public_path__ + "static/media/EmailSent.b24dd298.svg";